import React from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { Icon } from "react-icons-kit";

const IconButton = ({
  handleClick,
  icon,
  label,
  title,
  sizeMin,
  size300,
  size500,
  size800,
  size1000,
  noUnderlineOnFocus
}) => {
  const settings = useSelector((state) => state.settings);

  function clickOnEnterOrSpace(e) {
    if (e.key === "Enter" || e.key === " ") {
      handleClick(e);
    }
  }

  return (
    <Container>
      <StyledIcon
        id={`${label}-element`}
        tabIndex={0}
        onKeyDown={clickOnEnterOrSpace}
        className="centered"
        icon={icon}
        aria-label={label}
        title={title || label}
        width="150"
        height="50"
        dark={settings.dark ? 1 : 0}
        ispowered={settings.homePowerIsOn ? 1 : 0}
        nounderlineonfocus={noUnderlineOnFocus ? 1 : 0}
        onClick={(e) => {
          if (handleClick) {
            handleClick(e);
          }
        }}
        size={
          settings.windowWidth < 300
            ? sizeMin || 20
            : settings.windowWidth < 500
            ? size300 || 24
            : settings.windowWidth < 800
            ? size500 || 26
            : settings.windowWidth < 1000
            ? size800 || 30
            : size1000 || 34
        }
      ></StyledIcon>
    </Container>
  );
};
export default IconButton;

const Container = styled.div`
  position: relative;
  width: fit-content;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const StyledIcon = styled(Icon)`
  background: transparent;

  color: ${(p) =>
    p.ispowered
      ? "var(--power3)"
      : p.dark
      ? "var(--text-dark)"
      : "var(--text-light)"};
  :hover {
    cursor: pointer;
		color: var(--hover);
  }
  :focus {
		color: var(--focus);
    outline: none;
    animation: hueShift infinite 8s;
    :after {
      position: absolute;
      left: 0;
      bottom: -3px;
      content: " ";
      width: 100%;
      height: 2px;
      background: var(--focus);
      display: ${({nounderlineonfocus}) => nounderlineonfocus ? "none":"block"}
    }
  }
  :active {
		position: relative;
    top: 1px;
    outline: none;
		color: var(--focus);
  }
`;
